import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"
import Sortable from "sortablejs"

// Connects to data-controller="admin--navigation-sorter"
export default class extends Controller {
  static values = {
    menuId: Number,
    lockVersion: Number
  }

  connect() {
    let nestedSortables = [].slice.call(this.element.querySelectorAll(".nested[data-navigation-sortable='true']"))
    nestedSortables.forEach(this.initializeSortable.bind(this))

    this.setObserver()
  }

  initializeSortable(target) {
    new Sortable(target, {
      group: "nested",
      animation: 150,
      handle: ".drag-handle",
      draggable: ".sortable-item[data-sortable-node='true']",
      fallbackOnBody: true,
      swapThreshold: 0.65,
      onStart: this.start.bind(this),
      onEnd: this.end.bind(this)
    })
  }

  start() {
    this.element.classList.add("is-sorting")
    this.dispatch("drag-start", { bubbles: true })
  }

  end(event) {
    const id = event.item.dataset.id
    const parentNode = event.item.closest(".nested")
    const position = event.newIndex + 1
    const parentId = parentNode.dataset.id || null

    this.dispatch("drag-end", { bubbles: true })
    window.setTimeout(() => this.element.classList.remove("is-sorting"), 120)
    this.updateHierarchy(id, parentId, position)
  }

  updateHierarchy(id, parentId, position) {
    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content
    const headers = {
      "Content-Type": "application/json",
      "Accept": "text/vnd.turbo-stream.html"
    }
    if (csrfToken) headers["X-CSRF-Token"] = csrfToken

    return fetch(`/admin/navigation_menus/${this.menuIdValue}/navigation_item_order.turbo_stream`, {
      method: "PATCH",
      headers,
      body: JSON.stringify({
        command: "move_within_tree",
        item_id: id,
        parent_id: parentId,
        position,
        lock_version: this.lockVersionValue
      })
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }
        return response.text()
      })
      .then((body) => {
        if (body.includes("<turbo-stream")) Turbo.renderStreamMessage(body)
      })
      .catch((error) => {
        console.error("Error updating navigation hierarchy:", error)
        alert("Failed to update navigation hierarchy. Please try again.")
        throw error
      })
  }

  setObserver() {
    const targetNode = this.element.querySelector(".nested.tree")
    if (!targetNode) return

    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === "childList") {
          const addedElements = mutation.addedNodes
          for (const element of addedElements) {
            if (element.classList && element.classList.contains("nested")) {
              let nestedSortables = [].slice.call(this.element.querySelectorAll(".nested[data-navigation-sortable='true']"))
              nestedSortables.forEach(this.initializeSortable.bind(this))
            }
          }
        }
      }
    })

    observer.observe(targetNode, { childList: true, subtree: true })
  }
}
